import {Label, StyledButton} from './styles';

type SwitchButtonProps = {
    onClick: () => void;
    icon: JSX.Element;
    text: string;
    color: 'white' | 'black';
    isActive?: boolean;
};

const SwitchButton = ({
    onClick,
    icon,
    text,
    color,
    isActive,
    ...props
}: SwitchButtonProps) => {
    return (
        <StyledButton onClick={onClick} isActive={isActive} color={color} {...props}>
            {icon}
            <Label>{text}</Label>
        </StyledButton>
    );
};

export default SwitchButton;
